module.exports = __webpack_public_path__ + "static/img/1-role.fa33ee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/1-role.png
// module id = bJBQ
// module chunks = 1